import BaseService from '../base';

class Attachment extends BaseService {}

export default new Attachment('attachments', 'Attachment');
